import { Component, OnInit, Input, ChangeDetectionStrategy, ViewChild, ElementRef } from '@angular/core';
import { OktaAuthService } from '@okta/okta-angular';
import { FclLoginService } from 'src/app/services/fcllogin.service';
import { ActivatedRoute, Router, RoutesRecognized, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/services/common.service';
import { CustomerService } from 'src/app/services/customer.service';
import { NavService } from 'src/app/services/nav.service';
import { FormGroup } from '@angular/forms';
import { Customers, Facilities } from 'src/app/model/customer';
import { Subscription, of, Observable, BehaviorSubject } from 'rxjs';
import { SortByPipe } from 'src/app/pipes/sort-by.pipe';
import { Facility } from 'src/app/model/facility';
import { BuFacility, LangList } from 'src/app/model/generic';
import { map, filter } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { IsLoadingService } from 'src/app/services/loading.service';
import { RefCodeService } from 'src/app/services/reverse/ref-code.service';
import { LookUpCodes } from 'src/app/model/lov';
import { OrderService } from 'src/app/services/order.service';
import { filterRequest } from 'src/app/model/order';
import { ItemService as ItemReverseService } from 'src/app/services/reverse/item.service';
import { ItemService } from 'src/app/services/item.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class HeaderComponent implements OnInit {
  @ViewChild('manageRetailers') manageRetailers: ElementRef;
  @ViewChild('customersSubMenu') customersSubMenu: ElementRef;
  @ViewChild('retailersSubMenu') retailersSubMenu: ElementRef;
  @ViewChild('languagesSubMenu') languagesSubMenu: ElementRef;  
  title = 'Fsc Customer Portal';
  retailerState = false;
  facilityState = false;
  langState = false;
  displayFacilitiesDropdown = false;
  showFlag = true;
  userName = '';
  facilityName = '';
  custId = '';
  facilityId = '';
  isOpen = false;
  activityEvents$: Observable<any>;
  @Input()
  isSmallScreen = false;

  @Input()
  showOpenCloseBtn = true;
  showManageCustomerBtn: boolean = false;
  showManageCustomerBtn$ = new BehaviorSubject(this.showManageCustomerBtn);
  currentBuFacility: BuFacility[] = [];
  currentBuFacility$ = new BehaviorSubject(this.currentBuFacility);
  customerName = '';
  customers: Customers[] = [];
  facilityList: Facilities[] = [];
  buFacility: BuFacility = new BuFacility();
  buFacilityArr: BuFacility[] = [];
  buFacilityArrwAccess: BuFacility[] = [];
  headerForm: FormGroup;
  @Input()
  opened = false;
  userSessionExtendPopup = false;

  customerSubscription$: Subscription;
  paramBuCode: any;
  paramFcyCode: any;
  params$: Observable<{[key: string]: string}>;
  successContent: string;
  errorMessage = '';
  langList: any = [
    // { code: 'en', lang: 'English' }
  ];
  langCode: string = '';
  userLang: string = '';
  selLang: string = '';
  displayLangConfirmModal = false;
  userDBLang: string = '';
  userTempLang: string = '';
  displaySuccessModal = false;
  saveLangLoader = false;
  domainList: string[] = [
    'LANGUAGES_LIST'
  ];
  languageList: LookUpCodes[] = [];  
  //langList: LangList[] = [];
  toggleXsMenu = false;
  constructor(
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
    private fclLoginService: FclLoginService,
    private navService: NavService,
    private sortByPipe: SortByPipe,
    public router: Router,
    public customerService: CustomerService,  
    public commonService: CommonService,
    private toastr: ToastrService,
    public loadingService: IsLoadingService,
    private lookupSvc: RefCodeService,
    public itemService: ItemService,
    public itemReverseService: ItemReverseService,
    private orderService: OrderService,
    // public oktaAuth: OktaAuthService
  ) {
    const customers = this.navService.getSelectedCustomer();
    const facility = this.navService.getSelectedBusinessFacility();

    if (facility === undefined || facility === null) {
      this.navService.removeBusinessFacility();
      this.selectedBuFacility(null);
    }

    if (customers === undefined || customers === null) {
      this.custId = '';
      this.userName = '';
    } else {
      this.custId = '' + customers.customerId;
      this.selectedCustomer(customers);
      this.userName = customers.customerName;
      this.populateFacilityDropdown(customers);
    }
    this.params$ = router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map(e => this.getParams(this.activatedRoute))
    )
    this.redirectTo('home', 'no-reload');
  }
  
  ngOnInit() {
    this.assignLangList();
    // this.userDBLang = localStorage.getItem('userDBLang');
    // this.userTempLang = localStorage.getItem('userTempLang');
    // if(this.userTempLang){
    //   this.onChangeLanguage(this.userTempLang);
    // } else if(this.userDBLang){
    //   this.onChangeLanguage(this.userDBLang);
    // } else {
    //   this.onChangeLanguage('en');
    // }
    this.navService.userCustomers$.subscribe((res) => { this.customers = res; });
    this.getCustomerDetails();
    this.showManageCustomerBtn$.subscribe(res => {
      this.showManageCustomerBtn = res;
    });
    this.preCustLoadChecks();    
  }

  assignLangList() {
    if(!this.commonService.allLanguageList.length) {
      const selectedCustomer = this.commonService.getSelectedCustomer();
      const selectedFacility = this.commonService.getSelectedFacility();
      const selectedBusinessUnit = this.commonService.getSelectedBusinessUnit();
      
      this.lookupSvc
      .getKeyValue(this.domainList, '', '', selectedFacility?.facilityID, selectedCustomer?.customerId, selectedBusinessUnit?.buId)
      .subscribe(async data => {
        await data;
        if (data.success) {
          this.languageList =  data.lookups.find(key => key.lookupName === 'LANGUAGES_LIST') !==
              undefined
              ? data.lookups.find(key => key.lookupName === 'LANGUAGES_LIST')
                .lookupCodes
              : [];          
              this.addLangList(); 
              this.commonService.allLanguageList = this.languageList;
        }
        else{    

          this.errorMessage = this.translateService.instant('COMMON.CommonMessage_Somethingwentwrong', {Default: 'Something Went Wrong!'});  

        }
      },
        error =>{
          console.log(error);
            this.errorMessage = this.translateService.instant('COMMON.CommonMessage_Somethingwentwrong', {Default: 'Something Went Wrong!'});    

        }
      
      );
      
    }
    else{
      this.languageList = this.commonService.allLanguageList;
      this.addLangList(); 
    }
  }

  addLangList(){
    this.langList = [];
    
    if(this.languageList.length === 0){
      this.langList  = [
            { code: 'en', lang: 'English' }
          ];
    }
   
    else{
      for(let i=0 ; i<this.languageList.length; i++){
        let languList  = new LangList();

        languList.code = this.languageList[i].lookupCode;
        languList.lang = this.languageList[i].lookupCodeDescription;

        this.langList.push(languList);
    }
    }
   

    this.userDBLang = localStorage.getItem('userDBLang');
    this.userTempLang = localStorage.getItem('userTempLang');
    if(this.userTempLang){
      this.onChangeLanguage(this.userTempLang);
    } else if(this.userDBLang){
      this.onChangeLanguage(this.userDBLang);
    } else {
      this.onChangeLanguage('en');
    }
  }
  //for il8n
  public onChangeLanguage(lang): void {
    this.userLang = lang;
    this.langCode = this.langList.filter( e => e.code == this.userLang)[0].lang;
    this.translateService.setDefaultLang(this.userLang);
  }

  public onSwitchLanguage(lang): void {
    this.selLang = lang;
    // this.displayLangConfirmModal = true;
    this.handleModalEvent('switch');
    this.langState = false;
  }

  handleModalEvent(action: string) {
    if (action === 'save') {
      this.saveLangLoader = true;
      this.fclLoginService.updateUserLocale(localStorage.getItem('USER-ID'), this.selLang).subscribe(
        res => {
          if (res.success) {
            this.saveLangLoader = false;
            localStorage.setItem('userDBLang', this.selLang);
            this.userLang = this.selLang;
            this.userDBLang = this.selLang;
            this.langCode = this.langList.filter( e => e.code == this.userLang)[0].lang;

            this.translateService.setDefaultLang(this.userLang);
            this.closeModal();
            this.displaySuccessModal = true;
            this.successContent = this.translateService.instant('COMMON.CommonMessage_Languageupdatedsuccessfully', {Default: 'Language Updated successfully.'});
          }
        }
      );
    } else if (action === 'switch') {
      localStorage.setItem('userTempLang', this.selLang);
      this.userLang = this.selLang;
      this.langCode = this.langList.filter( e => e.code == this.userLang)[0].lang;
      this.translateService.setDefaultLang(this.userLang);
      this.closeModal();
    } else {
      this.closeModal();
    }
  }

  handleCloseEventForSuccess() {
    this.displaySuccessModal = false;
  }

  closeModal() {
    this.displayLangConfirmModal = false;
  }

  onHoverLang(event: MouseEvent) {
    if(event.type === 'mouseenter') {
      this.langState = true;
    } else if(event.type === 'mouseleave') {
      this.langState = false;
    }
  }

  toggleMenu() {
    this.opened = !this.opened;
  }
  private getParams(route: ActivatedRoute){
    // route param names (eg /a/:personId) must be ditinct within
    // a route otherwise they'll be overwritten
    let params = route.snapshot.params
    params = { ...route.snapshot.queryParams, ...params}
    if(route.children){
      for(let r of route.children){
        params = {...this.getParams(r), ...params};        
      }
    }
    return params;
  }

  /** Preloader checks */
  preCustLoadChecks() {
    let queryRootParams: any = '';
    queryRootParams = this.getParams(this.activatedRoute);
    if(queryRootParams){
      this.paramBuCode = queryRootParams.buCode,
      this.paramFcyCode = queryRootParams.fcyCode;

      if(this.paramBuCode != null || this.paramBuCode !== undefined){
        this.customerSubscription$ = this.customerService
          .getCustomerDetailsviaBUName(this.paramBuCode, 'details')
          .subscribe(
            async data => {
              await data;
              if (data.customers && data.customers.length > 0) {
                this.navService.setSelectedCustomer(data.customers[0]);
                this.selectedCustomer(data.customers[0], 'details');
                if(this.paramBuCode != null || this.paramBuCode !== undefined){
                  console.log('buFacilityArrwAccess ', this.buFacilityArrwAccess);
                  let paramBUFacility = data.customers[0].businessUnits[0].businessUnitName +'-'+ this.paramFcyCode;
                  let selBUFacility = this.buFacilityArr.filter(u => u.lookupCodeDescription === paramBUFacility);
                  this.navService.setSelectedBusinessFacility(selBUFacility[0]);
                } else {
                  this.selectedBuFacility(null);
                }
                this.navService.setSelectedModule('Operations Management');
                this.navService.setMenuPermissions('1GP8_P1_C0');
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    }
        
        
  } 

  async getCustomerDetails() {
    this.customers = [];
    this.showFlag = false;
    this.navService.getAuthorizedMenus().subscribe(res => {
      // console.log('getAuthorizedMenus');
      this.navService.setModulesInLocalStorage(res);
      this.navService.getLocalModules();
      if(!this.customerService.allCustomerList.length)
      {
        this.navService.getCustomers().subscribe(data => {
        this.customers = data.customers;      
        this.customers = this.sortByPipe.transform(
          this.customers,
          true,
          'asc',
          'customerName'
        );
        this.navService.custList = this.customers;
        this.navService.changeUserCustomers(this.customers);
        this.checkUserType();
        this.customerService.allCustomerList = this.customers;        
      });
    }
    else {
      this.customers = this.customerService.allCustomerList;   
    }

    });
    this.showFlag = true;
  }

  checkUserType() {
    if (this.fclLoginService.getUserType() === 'E') {
      this.showManageCustomerBtn$.next(false);
      if (this.customers !== undefined && this.customers.length === 1) {
        this.navService.setSelectedCustomer(this.customers[0]);
        this.selectedCustomer(this.customers[0]);
        this.userName = this.customers[0].customerName;
        this.populateFacilityDropdown(this.customers[0]);
      }
    } else {
      this.showManageCustomerBtn$.next(true);
      const defaultCustomer = new Customers();
      defaultCustomer.customerId = -1;
      defaultCustomer.customerName = this.translateService.instant('APP.AppOption_Pleaseselect', {Default: 'Please Select'});
      this.customers.unshift(defaultCustomer);
    }
  }

  toggle() {
    this.navService.toggleNav();
  }

  toggleXsMainMenu(){
    this.toggleXsMenu = !this.toggleXsMenu;
  }

  async logout() {

    this.navService.deleteAllCookies();

    if (this.fclLoginService.getUserType() === 'I' || this.fclLoginService.getUserType() === 'T') {
      // setTimeout(() => {
      this.fclLoginService.user = undefined;
      this.fclLoginService.clearLocalStorage();
      await this.fclLoginService.oktaAuth.logout('/');
      // }, 2000);
    } else if (this.fclLoginService.getUserType() === 'E') {
      this.fclLoginService.user = undefined;
      this.fclLoginService.isUserLoggedIn = false;
      this.fclLoginService.clearLocalStorage();
      setTimeout(() => {
        this.router.navigate(['/']);
      }, 300);
    }
  }

  selectedCustomer(customer, action?) {
    this.commonService.isEnrollmentTypeAvailable();
    
    // Set customer data first before any redirect
    this.displayFacilitiesDropdown = false;
    this.userName = customer.customerName;
    const custId = customer.customerId;
    if (custId === '' || custId === -1) {
      this.userName = '';
      this.navService.removeCustomer();
    } else {
      this.navService.setSelectedCustomer(customer);
      // Refresh language list when customer changes
      this.commonService.allLanguageList = [];
    }
    this.navService.facAccessList = customer.customerId;
    this.populateFacilityDropdown(customer);
    this.navService.getLocalModules();
    
    if (action === 'reload') {
      this.navService.removeBusinessFacility();
      this.selectedBuFacility(null);
      
      // Update login time first, then redirect
      this.fclLoginService.updateUserAndFacilityLastLoginTime(localStorage.getItem('USER-ID'), customer.customerId).subscribe(
        res => {
          if (res.success) {
            this.successContent = this.translateService.instant('COMMON.CommonMessage_Updatefacilitylastlogintimewassuccessful', {Default: 'Update Facility last login time was successful.'});         
          } else {
            console.log(res.errors)            
            this.errorMessage = res.errors[0].description;
          }
          // Redirect after the API call completes
          this.navService.setMenuName('Home');
          this.redirectTo('home', action);

           // Clear item filter state
          this.itemService.clearFilterRequest();
          // Clear reverse item filter state
          this.itemReverseService.clearFilterRequests();
          // Clear order filter state
          this.orderService.clearFilterRequest();
          // Clear RTV (Return to Vendor) order filter state
          this.orderService.clearFilterRTVRequest;
        },
        error => {
          console.log(error);
          this.errorMessage = this.translateService.instant('COMMON.CommonMessage_Somethingwentwrong', {Default: 'Something Went Wrong!'});
          // Redirect even if API call fails
          this.redirectTo('home', action);        
        }
      );    
    }
  }

  checkRetailer(event: MouseEvent) {
    if(event.type === 'mouseenter') {
      this.retailerState = true;
    } else if(event.type === 'mouseleave') {
      this.retailerState = false;
    }
    let windowWidth = window.innerWidth;
    if(windowWidth < 1025){
      let retailDropDown = this.manageRetailers.nativeElement;
      let rightPositionValue = retailDropDown.getBoundingClientRect().width;
      let customersDropdown = this.customersSubMenu.nativeElement;
      rightPositionValue = rightPositionValue + 8;
      customersDropdown.style.left = -rightPositionValue + 'px';
      this.retailersSubMenu.nativeElement.style.left = -rightPositionValue + 'px';
      this.languagesSubMenu.nativeElement.style.left = -rightPositionValue + 'px';
    }
  }

  onHoverFacility(event: MouseEvent) {    
    if(event.type === 'mouseenter') {
      this.facilityState = true;
    } else if(event.type === 'mouseleave') {
      this.facilityState = false;
    }
  }

  populateFacilityDropdown(customer, action?) {
    let buFacility = new BuFacility();
    const buFacilityArr = [];
    this.buFacilityArr = [];

    const facilityList = [];
    this.facilityList = [];

    if (customer.businessUnits.length !== 0) {
      for (const bu of customer.businessUnits) {
        for (const fac of bu.facilities) {
          buFacility.lookupCode = bu.buId + '~~' + fac.facilityID;
          buFacility.lookupCodeDescription =
            bu.businessUnitName + '-' + fac.facilityName;
          buFacility.bu = bu;
          buFacility.facility = fac;

          buFacilityArr.push(buFacility);
          buFacility = new BuFacility();
        }
      }

      /** removes non unique values */
      this.buFacilityArr = buFacilityArr.filter(
        (item, i, ar) => ar.indexOf(item) === i
      );

      this.buFacilityArr = this.buFacilityArr.filter(
        (test, index, array) =>
          index ===
          array.findIndex(findTest => findTest.lookupCode === test.lookupCode)
      );

      this.buFacilityArr = this.sortByPipe.transform(
        this.buFacilityArr,
        true,
        'asc',
        'lookupCodeDescription'
      );

      this.buFacilityArrwAccess = this.buFacilityArr.filter(x =>
        this.navService.facAccessList
          .map(y => y.lookupCode)
          .includes(x.lookupCode)
      );

      if (customer.enrollmentType === 'FL' || customer.enrollmentType === 'FT' || customer.enrollmentType === 'MA' || this.commonService.enrollmentTypeExist) {
        this.displayFacilitiesDropdown = true;
        const bufacility = this.navService.getSelectedBusinessFacility();

        if (bufacility === null && this.buFacilityArrwAccess.length === 1) {
          this.currentBuFacility$.next(this.buFacilityArrwAccess);
          this.selectedBuFacility(this.buFacilityArrwAccess[0]);
        }

        if (buFacility !== null) {
          this.selectedBuFacility(bufacility);
        }

        if (this.buFacilityArrwAccess.length > 1) {
          const defaultBuFacility = new BuFacility();
          defaultBuFacility.lookupCode = '-1';
          defaultBuFacility.lookupCodeDescription = this.translateService.instant('APP.AppOption_Pleaseselect', {Default: 'Please Select'});
            this.buFacilityArrwAccess.unshift(defaultBuFacility);
        }
      } else {
        this.displayFacilitiesDropdown = false;
      }
    }
  }

  selectedBuFacility(buFacility, action?) {
    if (action === 'reload') {
      this.redirectTo('home', action);
    }

    if (
      buFacility === undefined ||
      buFacility === null ||
      buFacility.lookupCode === '-1'
    ) {
      this.facilityId = '';
      this.facilityName = '';
    } else {
      if (buFacility.length === 1) {
        this.facilityId = buFacility.lookupCode;
        this.facilityName = buFacility.lookupCodeDescription;
        this.navService.setSelectedBusinessFacility(buFacility);
      } else {
        this.facilityId = buFacility.lookupCode;
        this.facilityName = buFacility.lookupCodeDescription;
        this.navService.setSelectedBusinessFacility(buFacility);
      }
    }
  }

  redirectTo(uri: string, action?) {
    if (action === 'reload') {
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigate([uri]));
    }
  }
}
